// extracted by mini-css-extract-plugin
export default {"list":"zw003lCz4Ieoky2V8ZaJ"};